import Vue from 'vue'
import App from './App'
import axios from 'axios'
import Router from 'vue-router'
import VueRouter from 'vue-router'
import router from './router'
import Vuex from 'vuex'
import store from './store'
// import '@/assets/font.css'

import { getLocalStorage } from '@/utils/index'

// Frament
import Fragment from 'vue-fragment'
Vue.use(Fragment.Plugin)

// ElementUI 
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

// Vue-Swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)

// Moment
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')
Vue.prototype.$moment = moment

// Vue-mobile-calendar
import Calendar from 'vue-mobile-calendar'
Vue.use(Calendar);

// Mint UI
import Mint from 'mint-ui';
import 'mint-ui/lib/style.css';
Vue.use(Mint);

// Language
import VueI18n from 'vue-i18n'
Vue.use(VueI18n) 

const i18n = new VueI18n({
  // locale: 'TC',
  locale: localStorage.getItem('lang') ? localStorage.getItem('lang') !== 'TC' && localStorage.getItem('lang') !== 'EN' ? 'TC' : localStorage.getItem('lang') : 'TC', // 语言标识
  //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    EN: require('./language/english'), // 英文
    zh_cn: require('./language/zh_cn'), // 中文
    TC: require('./language/tc'), // 繁体
    JP: require('./language/jp') // 日文
  }
})

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(Vuex)

/* eslint-disable no-new */


// 修正vue-router新版本报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

//全局过滤器
import * as filters from './filter'
Object.keys(filters).forEach(key=>{
    Vue.filter(key,filters[key])//插入过滤器名和对应方法
})

import VueLazyload from 'vue-lazyload'
// Vue.use(VueLazyload) //无配置项
// 配置项
import errorimage from '@/assets/default.png'

Vue.use(VueLazyload, {
  preLoad: 1.3, //预加载的宽高比
  error: errorimage, //图片加载失败时显示的图片
  attempt: 2, // 加载错误后最大尝试次数
})


import '@adyen/adyen-web/dist/cjs/adyen.css';

router.beforeEach(async (to,from,next)=>{         //to--即将要进入的路由 from--当前导航正要离开的路由
  window.document.title = i18n.t('pagetitle.'+ to.meta.title)
  // if ((to.name !== '登录') && !getLocalStorage(store.state.userToken)) {
  //   next ({name: '登录'})
  // }
  next()
})

router.afterEach(async (to, from) => {
  if (!to.meta.keepAlive){
    window.scrollTo(0,0)
  }
})

Vue.prototype.isMobile = (function() {
  const userAgentInfo = navigator.userAgent;
  const mobileAgents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
  for (let i = 0; i < mobileAgents.length; i++) {
    if (userAgentInfo.indexOf(mobileAgents[i]) > 0) {
      return true; // 是移动设备
    }
  }
  return false; // 是PC设备
})()

new Vue({
  el: '#app',
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount("#app")



// WEBPACK FOOTER //
// ./src/main.js